// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__5OMm1","col":"styles_col__EogYz"};